import { Plan } from '../../types/domain';

export interface OrganizationViewProps {
  section?: 'overview' | 'projects' | 'members' | 'settings';
}

export type OrgTabKey = 'overview' | 'projects' | 'team' | 'settings';
export type OrgSettingsTabKey = 'general' | 'plan' | 'danger';

export const formatBillingDate = (d?: string | null): string => {
  if (!d) return '—';
  try {
    const date = new Date(d);
    if (isNaN(date.getTime())) return '—';
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return '—';
  }
};

export const getDaysRemaining = (endDateStr?: string | null): number => {
  if (!endDateStr) return 0;
  try {
    const end = new Date(endDateStr).getTime();
    const now = Date.now();
    if (isNaN(end)) return 0;
    const diff = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
    return Math.max(0, diff);
  } catch {
    return 0;
  }
};

export const formatBytes = (bytes?: number): string => {
  if (!bytes || bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i = 0;
  let val = bytes;
  while (val >= 1024 && i < units.length - 1) {
    val /= 1024;
    i++;
  }
  return `${val.toFixed(val >= 10 || i === 0 ? 0 : 1)} ${units[i]}`;
};

export const getPlanRank = (planOrSlug: any, plans: Plan[] = []): number => {
  if (!planOrSlug) return 0;
  if (typeof planOrSlug === 'object') {
    if (typeof planOrSlug.position === 'number' && planOrSlug.position > 0) {
      return planOrSlug.position * 10;
    }
    if (typeof planOrSlug.price_monthly_cents === 'number' && planOrSlug.price_monthly_cents > 0) {
      return planOrSlug.price_monthly_cents;
    }
  }
  const s = (typeof planOrSlug === 'string' ? planOrSlug : planOrSlug?.slug || '').toLowerCase().trim();
  const found = plans.find((p) => p.slug.toLowerCase() === s);
  if (found) {
    if (typeof found.position === 'number' && found.position > 0) {
      return found.position * 10;
    }
    if (typeof found.price_monthly_cents === 'number' && found.price_monthly_cents > 0) {
      return found.price_monthly_cents;
    }
  }
  if (s === 'ultra' || s === 'enterprise') return 40;
  if (s === 'max') return 30;
  if (s === 'pro') return 20;
  if (s === 'free') return 10;
  return 0;
};
